export default __webpack_public_path__ + "static/media/phone-2.84626b34.svg";